module.exports = __webpack_public_path__ + "img/top1_right.27fbdcfe.png";